import ChallengesPage from './ChallengesPage';

export default ChallengesPage;
